// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import "amfe-flexible"
import { Button,Form,Field,Image as VanImage,Icon,Notify,Dialog,Toast,CellGroup,Calendar,RadioGroup,Radio } from 'vant';
import {getCookie} from "./utils/cookie";

Vue.config.productionTip = false
Vue.use(Button);
Vue.use(Form);
Vue.use(Field);
Vue.use(VanImage);
Vue.use(Icon);
Vue.use(Notify);
Vue.use(Dialog);
Vue.use(Toast);
Vue.use(CellGroup);
Vue.use(Calendar);
Vue.use(Radio);
Vue.use(RadioGroup);

router.beforeEach((to, from, next) => {
  if (to.path !== '/login') {
    try {
      if (parseInt(getCookie('expiredTime')) > new Date().getTime()) {
        next()
      }else {
        next({ path: '/login' })
      }
    }catch (err){
      next({ path: '/login' })
    }
  } else {
    next()
  }
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js